module.exports = "/fonts/vendor/@bcgov/bootstrap-theme/dist/bc-sans/BCSans-Italic.woff?4d39fafa1fad12c1fa9146997f3496ef";